/**
 * Open items the Exceptions page lists, summed the way its cards count them:
 * every routing and handover section (`counts` from GET approvals/exceptions)
 * plus the probation and document cards. A card the admin cannot read is
 * passed as `undefined` and adds nothing, like the page hides it.
 */
export const countOpenExceptions = (
  counts: Record<string, number> | undefined,
  probationRows: readonly unknown[] | undefined,
  documentRows: readonly unknown[] | undefined
): number =>
  Object.values(counts ?? {}).reduce(
    (sum, count) => sum + (Number.isFinite(count) ? count : 0),
    0
  ) +
  (probationRows?.length ?? 0) +
  (documentRows?.length ?? 0);
